import { changeDevActAs, reloadDevIdentity } from "../data/devActAsClient.js";
import { clearClientRolePreview, setClientRolePreview } from "../utils/demoRolePreview.js";
import { beginFeedback, commitFeedback, failFeedback, getFeedbackSnapshot } from "./devActAsFeedback.js";

// One synchronous lock (beginFeedback) across the banner and account menu.
// A role-only return reuses feedback/reload verification, not a person mutation.
export async function transitionDevIdentity(status, { targetId = null, name = null, preview = null, roleOnly = false } = {}) {
  if (!beginFeedback(status, targetId, name)) return false;
  let intent = getFeedbackSnapshot().feedback;
  try {
    const changed = roleOnly ? status : await changeDevActAs(targetId);
    // A timed-out/replaced request must not commit a newer action's feedback.
    if (getFeedbackSnapshot().feedback !== intent) return false;
    if (roleOnly) clearClientRolePreview();
    if (preview) setClientRolePreview(preview);
    commitFeedback(changed);
    intent = getFeedbackSnapshot().feedback;
    reloadDevIdentity();
    return true;
  } catch (error) {
    if (getFeedbackSnapshot().feedback === intent) failFeedback(error);
    throw error;
  }
}
